(function () {
  'use strict';

  function initReviewsSlider(section) {
    var track     = section.querySelector('.swiper-wrapper');
    var prevBtn   = section.querySelector('.mtrx-rev-arrow--prev');
    var nextBtn   = section.querySelector('.mtrx-rev-arrow--next');
    var counterEl = section.querySelector('.mtrx-rev-counter__current');
    var slides    = section.querySelectorAll('.mtrx-rev-slide');

    if (!track || slides.length === 0) return;

    var total   = slides.length;
    var current = 0;
    var timer   = null;

    function goTo(idx) {
      current = ((idx % total) + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      if (counterEl) {
        counterEl.textContent = (current + 1) < 10 ? '0' + (current + 1) : '' + (current + 1);
      }
    }

    function startAutoplay() {
      clearInterval(timer);
      timer = setInterval(function () { goTo(current + 1); }, 6000);
    }

    function stopAutoplay() { clearInterval(timer); }

    if (prevBtn) prevBtn.addEventListener('click', function () { stopAutoplay(); goTo(current - 1); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stopAutoplay(); goTo(current + 1); startAutoplay(); });

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    goTo(0);
    startAutoplay();
  }

  function init() {
    document.querySelectorAll('.mtrx-reviews').forEach(initReviewsSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
